import { createSelector } from "reselect";

import { selectFeatureFlags } from "ee/selectors/featureFlagsSelectors";
import { getAppsmithConfigs } from "ee/configs";

/**
 * Checks if the release_query_module_enabled feature flag is enabled and if the
 * current instance is cloud hosted. This is the base condition for enabling
 * query modules + the base functionalities of packages.
 *
 * @returns boolean
 */
export const getShowQueryModule = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    const { cloudHosting } = getAppsmithConfigs();

    return !cloudHosting && featureFlags.release_query_module_enabled;
  },
);

/**
 * Checks if the release_ui_module_enabled feature flag is enabled and if the
 * current instance is cloud hosted. This is the base condition for enabling
 * ui modules only. To enable all features and UI modules both release_query_module_enabled
 * and release_ui_module_enabled has to be enabled
 *
 * @returns boolean
 */
export const getShowUIModule = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    const { cloudHosting } = getAppsmithConfigs();

    return !cloudHosting && featureFlags.release_ui_module_enabled;
  },
);

export const getShowModuleReference = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    const { cloudHosting } = getAppsmithConfigs();

    return (
      !cloudHosting &&
      featureFlags.release_query_module_enabled &&
      featureFlags.release_module_reference_enabled
    );
  },
);

export const getPackagePullFeature = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    const { cloudHosting } = getAppsmithConfigs();

    return !cloudHosting && featureFlags.release_jit_package_pull_enabled;
  },
);
